import axios, { AxiosRequestConfig, AxiosResponse } from "axios";


//const LAMBDA_BASE_URL = 'https://m2uq1kqgz4.execute-api.us-west-2.amazonaws.com/prod';

// Usar proxy through tu backend que YA tiene CORS configurado
/* const BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://m2uq1kqgz4.execute-api.us-west-2.amazonaws.com/prod'
  : 'http://localhost:3600/api/aws'; // ← Tu backend con CORS 
 */
const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "http://172.25.2.4:3500/api/" 
    : process.env.REACT_APP_API_BASE_URL+ "/api"; //"http://localhost:3500/api/"; // ← Tu backend con CORS

// Configuración de reintentos
const RETRY_CONFIG = {
  maxRetries: 3,
  retryDelay: 1000, // 1 segundo
  retryOnStatus: [429, 500, 502, 503, 504],
  retryOnNetworkError: true,
  retryOnTimeout: true,
};

console.log("BASE_URL", BASE_URL);

// Función de delay
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// Función para determinar si se debe reintentar
const shouldRetry = (error: any): boolean => {
  // Request cancelado por el usuario/navegador
  if (axios.isCancel(error)) {
    console.log("Request cancelado, no se reintenta");
    return false;
  }

  // Error de red (sin respuesta del servidor)
  if (!error.response) {
    return RETRY_CONFIG.retryOnNetworkError;
  }

  // Timeout
  if (error.code === "ECONNABORTED") {
    return RETRY_CONFIG.retryOnTimeout;
  }

  // Códigos de estado específicos
  const status = error.response.status;
  return RETRY_CONFIG.retryOnStatus.includes(status);
};

// Cliente HTTP con reintentos
export const awsApiWithRetry = async <T>(
  config: AxiosRequestConfig,
  retryCount: number = 0
): Promise<AxiosResponse<T>> => {
  try {
    const response = await awsApi.request<T>(config);
    return response;
  } catch (error) {
    // Verificar si debemos reintentar
    if (retryCount < RETRY_CONFIG.maxRetries && shouldRetry(error)) {
      const nextRetryCount = retryCount + 1;
      const delayTime = RETRY_CONFIG.retryDelay * Math.pow(2, retryCount); // Exponential backoff

      console.log(`Reintento ${nextRetryCount} en ${delayTime}ms...`);

      await delay(delayTime);
      return awsApiWithRetry<T>(config, nextRetryCount);
    }

    // Si no se reintenta o se agotaron los reintentos, lanzar error
    throw error;
  }
};

export const awsApi = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Interceptor para agregar el token de autorización
awsApi.interceptors.request.use(
  (config) => {
    // config.headers.Authorization = `Bearer ${
    //   localStorage.getItem("authToken") || "dev-token-12345"
    // }`;
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (!(config.data instanceof FormData)) {
      config.headers["Content-Type"] = "application/json";
    } else {
      // axios se encarga del boundary en multipart/form-data
      delete config.headers["Content-Type"];
    }

    // Agregar timestamp para evitar cache
    if (config.method?.toLowerCase() === "get") {
      // Excluir endpoints específicos que no necesitan cache busting
      const excludedEndpoints = ["/products/aws/"];

      const shouldAddTimestamp = !excludedEndpoints.some((endpoint) =>
        config.url?.includes(endpoint)
      );

      if (shouldAddTimestamp) {
        config.params = {
          ...config.params,
          _t: Date.now(),
        };
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores
awsApi.interceptors.response.use(
  (response) => {
    // Si la respuesta tiene la estructura Lambda, parsear el body
    if (response.data && typeof response.data.body === "string") {
      try {
        response.data = JSON.parse(response.data.body);
      } catch (error) {
        console.error("Error parsing Lambda response body:", error);
      }
    }
    return response;
  },
  (error) => {
    //console.error("AWS API Error:", error.response?.data || error.message);
    if(error.response?.status === 401 || error.response?.status === 403) {
      console.warn("Token Expirado o inválido. Redirigiendo al login...");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/";
    }
    if(error.code === 'ECONNABORTED') {
      console.error("AWS API Error:", {
        message: error.message,
        code: error.code,
        status: error.response?.status,
        url: error.config?.url,
      });
    }

    return Promise.reject(error);
  }
);
